import { useEffect } from "react";
import { Container } from "../Container/Container";
import { Link } from "react-router-dom";
import { CharityArr } from "./CharityObj";
import { CharityBlock } from "./CharityBlock";
import {
  CharityWrapper,
  HeroBlock,
  Badge,
  Title,
  Accent,
  Card,
  CardTitle,
  IntroText,
  BulletList,
  BulletItem,
  DiscountsList,
  DiscountRow,
  DiscountSchool,
  DiscountValue,
  SectionTitle,
  CharityGridContainer,
} from "./styled";

const benefits = [
  "Лучшие ученики образовательной школы получают стипендии",
  "Все ученики 6–11 классов получают бесплатно дополнительный урок (факультативный час) по выбору: математика, физика, химия, литература",
  "Работают бесплатные студии: хоровая — для всех детей, театральная и танцевальная — для средней и старшей школы",
  "Семьи, оказавшиеся в трудной финансовой ситуации, получают дополнительные льготы",
  "Особые условия обучения для детей из Украины",
];

const discounts = [
  { name: "Villa Maria", link: "https://villamaria.qc.ca/en/", value: "10%" },
  { name: "Collège Français", link: "https://www.collegefrancais.ca/", value: "20%" },
  { name: "L'École des Premières Lettres", link: "https://www.premiereslettres.com/", value: "30%" },
];

export const Charity = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);

  return (
    <Container>
      <CharityWrapper>
        <HeroBlock>
          <Badge>Благотворительность</Badge>
          <Title>Дети — наше будущее</Title>
          <Accent />
        </HeroBlock>

        <Card>
          <IntroText>
            Центр ежегодно проводит благотворительные вечера. Полученные средства идут на благотворительные цели. Благодаря фонду <strong>«Дети — наше будущее»</strong>, Детский центр «Мечта» является учебной организацией, в которой:
          </IntroText>
          <BulletList>
            {benefits.map((b, i) => (
              <BulletItem key={i}>{b}</BulletItem>
            ))}
          </BulletList>
        </Card>

        <Card>
          <CardTitle>Скидки на обучение для учеников «Мечты»</CardTitle>
          <DiscountsList>
            {discounts.map((d) => (
              <DiscountRow key={d.name}>
                <DiscountSchool href={d.link} target="_blank" rel="noreferrer">
                  {d.name}
                </DiscountSchool>
                <DiscountValue>{d.value}</DiscountValue>
              </DiscountRow>
            ))}
          </DiscountsList>
        </Card>

        <SectionTitle>Благотворительные вечера прошлых лет</SectionTitle>
        <CharityGridContainer>
          {Object.entries(CharityArr).map(([key, value]) => (
            <Link key={key} to={`/charity/${key}`}>
              <CharityBlock photo={value.photo} title={value.title} />
            </Link>
          ))}
        </CharityGridContainer>
      </CharityWrapper>
    </Container>
  );
};
